import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaLinkedin, FaFacebookF, FaGoogle } from "react-icons/fa";

import useInput from "../../utils/useInput";

const Register = () => {
  const [firstname, bindFirstname] = useInput("");
  const [surname, bindSurname] = useInput("");
  const [email, bindEmail] = useInput("");
  const [password, bindPassword] = useInput("");
  const [confirmPassword, bindConfirmPassword] = useInput("");

  const [message, setMessage] = useState(null);
  let navigate = useNavigate();

  const FormSubmitHandler = function (e) {
    e.preventDefault();
    let form = {
      firstname,
      surname,
      email,
      password,
      confirmPassword,
    };

    fetch("https://atease-insurance.herokuapp.com/user/signup", {
      method: "POST",
      headers: { "Content-type": "application/json" },
      body: JSON.stringify(form),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "FAILED") {
          setMessage(data.message);
          setTimeout(() => {
            setMessage(null);
          }, 3000);
        } else if (data.status === "PENDING") {
          // set formSent to true to navigate to SentVerificationEmail page
          setMessage(data.message);
          setTimeout(() => {
            navigate("/login");
          }, 10000);
        }
      })
      .catch((err) => console.log(err));
  };

  return (
    <div>
      <div className="limiter mt-vh-20">
        <div className="container-login100">
          <div className="wrap-login100">
            <form
              onSubmit={FormSubmitHandler}
              className="login100-form validate-form"
            >
              <span className="login100-form-title">Register</span>

              <div
                className="wrap-input100 validate-input"
                data-validate="Firstname is required"
              >
                <span className="label-input100">Firstname</span>
                <input
                  className="input100"
                  type="text"
                  placeholder="Type your firstname"
                  {...bindFirstname}
                />
                <span className="focus-input100 contact"></span>
              </div>
              <div
                className="wrap-input100 validate-input"
                data-validate="Surname is required"
              >
                <span className="label-input100">Surname</span>
                <input
                  className="input100"
                  type="text"
                  placeholder="Type your surname"
                  {...bindSurname}
                />
                <span className="focus-input100 contact"></span>
              </div>
              <div
                className="wrap-input100 validate-input"
                data-validate="Email is required"
              >
                <span className="label-input100">Email</span>
                <input
                  className="input100"
                  type="text"
                  placeholder="Type your email"
                  {...bindEmail}
                />
                <span className="focus-input100 email"></span>
              </div>

              <div
                className="wrap-input100 validate-input"
                data-validate="Password is required"
              >
                <span className="label-input100">Password</span>
                <input
                  className="input100"
                  type="password"
                  autoComplete="off"
                  placeholder="Type your password"
                  {...bindPassword}
                />
                <span className="focus-input100 lock"></span>
              </div>

              <div
                className="wrap-input100 validate-input"
                data-validate="Password is required"
              >
                <span className="label-input100">Comfirm Password</span>
                <input
                  className="input100"
                  type="password"
                  autoComplete="off"
                  placeholder="Type your password"
                  {...bindConfirmPassword}
                />
                <span className="focus-input100 lock"></span>
              </div>

              {message && <p className="text-center p-t-100">{message}</p>}

              <div className="container-login100-form-btn mt-5">
                <div className="wrap-login100-form-btn">
                  <div className="login100-form-bgbtn"></div>
                  <button className="login100-form-btn">Register</button>
                </div>
              </div>

              <div className="txt1 text-center p-t-100">
                <span>Or sign up using</span>
              </div>

              <div className="flex-c-m">
                <Link to="#" className="login100-social-item bg1">
                  <FaFacebookF />
                </Link>

                <Link to="#" className="login100-social-item bg2">
                  <FaGoogle />
                </Link>

                <Link to="#" className="login100-social-item bg3">
                  <FaLinkedin />
                </Link>
              </div>

              <div className="flex-col-c p-t-100">
                <span className="txt1 p-b-17">Already have an account?</span>

                <Link to="/login" className="txt2">
                  Login
                </Link>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
